import {useMemo} from 'react'
import {PatientEditingFieldsGroup, usePatientDetailsStore} from '@/features/patients/store/usePatientDetailsStore'

export const usePatientEditModeView = (fieldsGroup: PatientEditingFieldsGroup) => {
    const currentEditingFieldsGroup = usePatientDetailsStore(state => state.editingFieldsGroup)
    const isEditModeEnabled = useMemo(() => currentEditingFieldsGroup == fieldsGroup, [currentEditingFieldsGroup])
    const isDisabledView = useMemo(
        () => !!currentEditingFieldsGroup && !isEditModeEnabled,
        [currentEditingFieldsGroup, isEditModeEnabled]
    )

    return {
        isEditModeEnabled,
        isDisabledView
    }
}
